import { Component } from "react";
import PropTypes from "prop-types";
import basicUtils from "../../utils/basic-utils";

const noop = basicUtils.noop;

class State extends Component {
  static displayName = "State";
  static propTypes = {
    initialState: PropTypes.object,
    render: PropTypes.func,
    onChange: PropTypes.func,
    children: PropTypes.func,
  };

  static defaultProps = {
    initialState: {},
  };

  state = {
    ...this.props.initialState,
  };

  handleChange = (updater, cb = noop) => {
    const { onChange = noop } = this.props;

    this.setState(updater, () => {
      onChange(this.state);
      cb();
    });
  };

  render() {
    const obj = { state: this.state, setState: this.handleChange };
    return typeof this.props.render === "function" ? this.props.render(obj) : this.props.children(obj);
  }
}

export default State;
